var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamingAmico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-123"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-123",
    cx: 249.53,
    cy: 345.84,
    rx: 231.15,
    ry: 133.46,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-123",
    d: "M428.59,369.86l-60.67-35a1.32,1.32,0,0,1,0-2.5l39-22.48a4.79,4.79,0,0,1,4.33,0l60.66,35a1.32,1.32,0,0,1,0,2.5l-39,22.49A4.79,4.79,0,0,1,428.59,369.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-123",
    cx: 165.86,
    cy: 377.6,
    rx: 101.93,
    ry: 58.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-123",
    cx: 262.08,
    cy: 365.69,
    rx: 66.39,
    ry: 38.33,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.51,327.72l.82-13s-.77-16.61-17.23-31.93c-10-9.31-18.27-4.3-20.34.77s-.35,12.76,9.37,19.95c15.22,11.25,28,29.06,29.66,41.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,324.05a.59.59,0,0,1-.62-.41c-7.49-24.8-29-39.68-29.27-39.83A.56.56,0,0,1,34,283a.58.58,0,0,1,.8-.16c.22.15,22.11,15.25,29.72,40.45a.59.59,0,0,1-.38.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.17,328.15a7,7,0,0,0-1.51-3.89c-1.6-1.85-4.4-2.45-5.75-4.5a16.83,16.83,0,0,1-1.28-3.2,10.24,10.24,0,0,0-5.23-5.37,13.79,13.79,0,0,0-7.51-1c-1.93.24-3.8.83-5.73,1.1-6.33.91-12.19-4.9-18.49-1-3.78,2.36-3.52,6.48-1.42,9.93a19,19,0,0,0,4.08,4.63c1.7,1.44,3.49,2.31,3.67,4.81.12,1.82-.45,3.63-.43,5.46a10.47,10.47,0,0,0,4,7.74,18,18,0,0,0,8.18,3.51c2.19.42,4.71.75,5.92,2.62a10.64,10.64,0,0,1,1,3.25,13.28,13.28,0,0,0,7.09,8.31,20.21,20.21,0,0,0,11,1.68,16.75,16.75,0,0,0,8.92-3.32c4.28-3.5,1.82-10.11-1-13.79-1.23-1.62-2.75-3-3.88-4.69-2.26-3.35-1.89-6.25-1.68-10.08A13.36,13.36,0,0,0,65.17,328.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.51,352.79a.47.47,0,0,1-.5-.23C52.7,325,28.14,317.3,27.89,317.22a.48.48,0,0,1-.32-.59.49.49,0,0,1,.6-.32c.25.08,25.17,7.9,40.67,35.79a.47.47,0,0,1-.18.64A.3.3,0,0,1,68.51,352.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.91,333.84H53.8c-6.73-.28-16.91,2.42-17,2.45a.46.46,0,0,1-.58-.34.47.47,0,0,1,.33-.58c.42-.11,10.43-2.77,17.3-2.48a.47.47,0,0,1,.07.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,329.27h0a.49.49,0,0,1-.53-.41,36.43,36.43,0,0,1,.27-10.22.47.47,0,0,1,.55-.37.47.47,0,0,1,.38.55,35.94,35.94,0,0,0-.25,9.92A.48.48,0,0,1,49,329.27Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.24,135.55,275.33,28.8c-2.78-1.6-5-.3-5,2.91V178.15a11.15,11.15,0,0,0,5,8.73L460.24,293.63c2.78,1.6,5,.3,5-2.91V144.28A11.15,11.15,0,0,0,460.24,135.55Z",
    style: {
      fill: "#C86868",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.24,135.55,275.33,28.8c-2.78-1.6-5-.3-5,2.91V178.15a11.15,11.15,0,0,0,5,8.73L460.24,293.63c2.78,1.6,5,.3,5-2.91V144.28A11.15,11.15,0,0,0,460.24,135.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.22,266.06V247.3l-12.19-7v14.08L445,252V228.54l-8.13-4.69v9.38l-4.06-2.35v18.76L424.66,245V230.88l-4.06-2.34v-4.69l-4.07-2.35v-4.69l-4.06-2.34v4.69l-4.06-2.35v4.69l-4.06-2.34v4.69l-8.13-4.69V205.09l-12.18-7V221.5L380,219.16V205.09l-8.13-4.7v14.08l-4.06-2.35v-4.69l-8.12-4.69v-9.38l-8.13-4.69v4.69L347.48,191v14.1l-4.06-2.35V184l-4.06-2.35v-4.69l-4.07-2.34v-4.69l-4.06-2.35v4.69l-4.06-2.34v4.69l-4.06-2.35V195.7l-4.06-2.34V184l-12.05-7v4.77l-8.27-4.77v-9.38l-4.07-2.34v-4.69l-4.06-2.35v-4.69l-4.06-2.34v4.68l-4.06-2.34v4.69l-4.06-2.35v9.39l-8.13-4.7v17.63a11.15,11.15,0,0,0,5,8.73L460.24,293.63c2.78,1.6,5,.3,5-2.91V268.41Z",
    style: {
      fill: "#C86868",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.08,29.12a3.64,3.64,0,0,1,1.75.55L459.74,136.41a10.24,10.24,0,0,1,4.54,7.87V290.72c0,.78-.18,2.59-1.79,2.59a3.64,3.64,0,0,1-1.75-.55L275.83,186a10.2,10.2,0,0,1-4.54-7.87V31.71c0-.78.18-2.59,1.79-2.59m0-1c-1.65,0-2.79,1.31-2.79,3.59V178.15a11.15,11.15,0,0,0,5,8.73L460.24,293.63a4.62,4.62,0,0,0,2.25.68c1.65,0,2.79-1.31,2.79-3.59V144.28a11.15,11.15,0,0,0-5-8.73L275.33,28.8a4.62,4.62,0,0,0-2.25-.68Z",
    style: {
      fill: "#C86868"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,104.55l80.17,46.29c4.79,2.76,8.66,9.47,8.66,15v22.21c0,5.52-3.87,7.76-8.66,5l-80.17-46.29c-4.78-2.76-8.66-9.47-8.66-15V109.55C315,104,318.86,101.79,323.64,104.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.68,194.74a8.34,8.34,0,0,1-4.12-1.26L323.39,147.2c-4.91-2.84-8.91-9.76-8.91-15.44V109.55c0-2.86,1-5,2.79-6s4.15-.82,6.62.61l80.17,46.28c4.92,2.84,8.91,9.76,8.91,15.44v22.21c0,2.86-1,5-2.78,6A5,5,0,0,1,407.68,194.74Zm-87.9-90.88a3.89,3.89,0,0,0-2,.52c-1.47.85-2.29,2.68-2.29,5.17v22.21c0,5.36,3.77,11.89,8.41,14.57l80.17,46.29c2.15,1.24,4.15,1.45,5.63.6s2.28-2.69,2.28-5.17V165.84c0-5.36-3.77-11.89-8.41-14.57L323.39,105A7.37,7.37,0,0,0,319.78,103.86Z",
    style: {
      fill: "#C86868"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.41,122.74a9.39,9.39,0,0,1,2.21,1.81,14.66,14.66,0,0,1,1.73,2.37,12.94,12.94,0,0,1,1.14,2.51,7.77,7.77,0,0,1,.44,2.19.46.46,0,0,1-.13.37.2.2,0,0,1-.27,0l-2.46-1.41a1.89,1.89,0,0,1-.42-.36,5.37,5.37,0,0,1-.33-.54c0-.08-.09-.21-.17-.39a4.62,4.62,0,0,0-.35-.62,5.53,5.53,0,0,0-.56-.7,3.65,3.65,0,0,0-.83-.64,5.13,5.13,0,0,0-.68-.32,1.45,1.45,0,0,0-.58-.1.57.57,0,0,0-.42.21,1,1,0,0,0-.16.63,2,2,0,0,0,.18.82,3.82,3.82,0,0,0,.6.88,13,13,0,0,0,1.12,1.12l1.72,1.55A16.29,16.29,0,0,1,340,134a10.59,10.59,0,0,1,1.29,2,9.74,9.74,0,0,1,.77,2.18,11.45,11.45,0,0,1,.25,2.5,5.57,5.57,0,0,1-.43,2.38,2.61,2.61,0,0,1-1.21,1.28,3,3,0,0,1-1.84.19,7.12,7.12,0,0,1-2.31-.9,10,10,0,0,1-2.33-1.86,14.4,14.4,0,0,1-1.81-2.42,13.19,13.19,0,0,1-1.19-2.61,8.17,8.17,0,0,1-.45-2.42.51.51,0,0,1,.12-.38.2.2,0,0,1,.27,0l2.46,1.42a1.28,1.28,0,0,1,.41.34,2.74,2.74,0,0,1,.3.47l.23.51a6.34,6.34,0,0,0,.4.76,4.85,4.85,0,0,0,.64.85,4,4,0,0,0,.95.75,4.09,4.09,0,0,0,1.66.62q.66.06.66-.81a1.72,1.72,0,0,0-.24-.86,5.3,5.3,0,0,0-.73-1c-.33-.35-.74-.75-1.25-1.2s-1.1-1-1.79-1.61A11.1,11.1,0,0,1,332,130.4a10.8,10.8,0,0,1-.89-4.48,5.89,5.89,0,0,1,.36-2.16,2.89,2.89,0,0,1,1.06-1.38,2.64,2.64,0,0,1,1.68-.4A5.26,5.26,0,0,1,336.41,122.74Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,133.82a.93.93,0,0,1,.36.43,1.53,1.53,0,0,1,.15.64V138a.61.61,0,0,1-.15.46.27.27,0,0,1-.36,0l-3.3-1.91v14.81a.63.63,0,0,1-.15.47.28.28,0,0,1-.36,0l-2.45-1.42a.93.93,0,0,1-.36-.43,1.53,1.53,0,0,1-.15-.64V134.53l-3.3-1.91a.93.93,0,0,1-.36-.43,1.53,1.53,0,0,1-.15-.64v-3.06a.61.61,0,0,1,.15-.46.27.27,0,0,1,.36,0Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.32,139.14a1.45,1.45,0,0,1,.57.65,3.9,3.9,0,0,1,.27.79l4.09,20.56a2.38,2.38,0,0,1,.07.47.52.52,0,0,1-.12.38.22.22,0,0,1-.29,0l-2.36-1.37a1.17,1.17,0,0,1-.53-.55,1.87,1.87,0,0,1-.2-.59l-.53-2.7-5-2.88-.52,2.09a.71.71,0,0,1-.2.37c-.1.1-.28.08-.53-.07L356.69,155a.79.79,0,0,1-.3-.36,1.19,1.19,0,0,1-.12-.51,1.41,1.41,0,0,1,.08-.39l4.09-15.83a1,1,0,0,1,.27-.48c.13-.14.32-.13.57,0Zm-3,10.87,3,1.75L362.8,144Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.84,147a11.2,11.2,0,0,1,2.21,1.68,10,10,0,0,1,1.66,2.17,10.47,10.47,0,0,1,1.05,2.67,12.71,12.71,0,0,1,.37,3.15,7.28,7.28,0,0,1-.58,3.26,2.14,2.14,0,0,1-1.65,1.22l2.32,8.22a1.22,1.22,0,0,1,.06.35.48.48,0,0,1-.12.37.23.23,0,0,1-.3,0l-2.55-1.47a1.22,1.22,0,0,1-.53-.57,4.19,4.19,0,0,1-.25-.66L377.45,160l-1.73-1v6.18a.61.61,0,0,1-.15.46.27.27,0,0,1-.36,0l-2.45-1.42a1,1,0,0,1-.36-.44,1.45,1.45,0,0,1-.15-.63V144.5a.62.62,0,0,1,.15-.46.28.28,0,0,1,.36,0Zm-2.12,7.53,2.12,1.22a1.67,1.67,0,0,0,1.3.29c.35-.11.52-.57.52-1.38a3.42,3.42,0,0,0-.52-2,3.86,3.86,0,0,0-1.3-1.21l-2.12-1.23Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.22,157.56a1,1,0,0,1,.35.44,1.47,1.47,0,0,1,.16.63v3.07a.62.62,0,0,1-.16.46.27.27,0,0,1-.35,0l-3.3-1.9v14.81a.62.62,0,0,1-.15.46.27.27,0,0,1-.36,0L390,174.16a1,1,0,0,1-.35-.44,1.45,1.45,0,0,1-.15-.63V158.27l-3.3-1.9a1,1,0,0,1-.36-.44,1.45,1.45,0,0,1-.15-.63v-3.06a.63.63,0,0,1,.15-.47.28.28,0,0,1,.36,0Z",
    style: {
      fill: "#C86868"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.58,45.33a13.49,13.49,0,0,1,6.09,10.56c0,3.88-2.73,5.46-6.09,3.51a13.43,13.43,0,0,1-6.09-10.55C282.49,45,285.21,43.39,288.58,45.33Z",
    style: {
      fill: "#C86868",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.1,53.26a5,5,0,0,0-.42-2h0v0a3.48,3.48,0,0,0-1.28-1.64c-.88-.52-1.61.53-1.73,1.77-.1-1.37-.82-3.27-1.7-3.79a1,1,0,0,0-1.29.13h0a2.29,2.29,0,0,0-.44,1.5c0,2.1,1.25,4,2.3,6l1.12,2.1,1.12-.79C290.83,55.77,292.1,55.36,292.1,53.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.86,55.89A13.46,13.46,0,0,1,313,66.44c0,3.89-2.73,5.46-6.09,3.52a13.47,13.47,0,0,1-6.09-10.56C300.77,55.52,303.49,53.94,306.86,55.89Z",
    style: {
      fill: "#C86868",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.3,63.84a5.23,5.23,0,0,0-.43-2h0a3.51,3.51,0,0,0-1.29-1.65c-.87-.51-1.61.54-1.72,1.78-.11-1.37-.83-3.28-1.7-3.79a1,1,0,0,0-1.3.13h0a2.27,2.27,0,0,0-.44,1.5c0,2.1,1.25,4,2.3,6l1.11,2.1L308,67.1C309,66.35,310.29,65.93,310.3,63.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.14,66.44A13.48,13.48,0,0,1,331.23,77c0,3.89-2.73,5.46-6.09,3.52A13.46,13.46,0,0,1,319,70C319,66.07,321.77,64.5,325.14,66.44Z",
    style: {
      fill: "#C86868",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.58,74.39a5.14,5.14,0,0,0-.43-2h0a3.55,3.55,0,0,0-1.29-1.64c-.88-.52-1.61.53-1.72,1.77-.11-1.37-.83-3.27-1.71-3.79a1,1,0,0,0-1.29.13h0a2.29,2.29,0,0,0-.45,1.5c0,2.1,1.25,4,2.31,6l1.11,2.1,1.12-.79C327.3,76.9,328.57,76.49,328.58,74.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,78.15l85.22,49.2a9.29,9.29,0,0,1,4.33,7.19c0,2.59-1.94,3.57-4.33,2.19L343,87.53a9.29,9.29,0,0,1-4.33-7.19C338.7,77.75,340.64,76.77,343,78.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.1,81.71a4.65,4.65,0,0,0,2.16,3.6l85.61,49.49c1.19.69,2.16.2,2.16-1.1a4.65,4.65,0,0,0-2.16-3.59L343.26,80.62C342.07,79.93,341.1,80.42,341.1,81.71Z",
    style: {
      fill: "#C86868",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437,135.29a.66.66,0,0,1,0-.3.21.21,0,0,1,.1-.19l1.93-1.17.18-.1a.27.27,0,0,1,.24,0l1.09.63a.41.41,0,0,1,.17.21.75.75,0,0,1,.08.31v8.95a.28.28,0,0,1-.08.22c0,.05-.1.05-.17,0l-1.18-.68a.47.47,0,0,1-.17-.21.82.82,0,0,1-.07-.3v-6.06l-1.07.63q-.07.06-.18,0a.5.5,0,0,1-.16-.23Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.14,136.72a4.2,4.2,0,0,1,1.16,1,5.53,5.53,0,0,1,.81,1.28,7.32,7.32,0,0,1,.48,1.48,10.25,10.25,0,0,1,.18,1.54c0,.4,0,.82,0,1.26s0,.83,0,1.21a6.48,6.48,0,0,1-.18,1.32,2.15,2.15,0,0,1-.48.93,1.17,1.17,0,0,1-.81.35,2.28,2.28,0,0,1-1.16-.37,4.35,4.35,0,0,1-1.16-1,5.85,5.85,0,0,1-.8-1.28,6.25,6.25,0,0,1-.48-1.48,9.13,9.13,0,0,1-.19-1.54c0-.38,0-.79,0-1.23s0-.85,0-1.24a5.83,5.83,0,0,1,.19-1.32,2,2,0,0,1,.48-.93,1.16,1.16,0,0,1,.8-.35A2.16,2.16,0,0,1,445.14,136.72Zm1,6.71c0-.78,0-1.55,0-2.33,0-.24,0-.47-.06-.68a3.77,3.77,0,0,0-.16-.6,1.92,1.92,0,0,0-.29-.5,1.71,1.71,0,0,0-.45-.39.75.75,0,0,0-.45-.13.4.4,0,0,0-.29.17,1.21,1.21,0,0,0-.16.41,5.07,5.07,0,0,0-.06.6c0,.75,0,1.53,0,2.33a4.63,4.63,0,0,0,.06.67,2.2,2.2,0,0,0,.16.6,1.83,1.83,0,0,0,.29.51,1.71,1.71,0,0,0,.45.39.75.75,0,0,0,.45.13.39.39,0,0,0,.29-.17,1,1,0,0,0,.17-.41A3.64,3.64,0,0,0,446.1,143.43Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.37,145.3a4.27,4.27,0,0,1-.06.74,2.25,2.25,0,0,1-.18.62,2,2,0,0,1-.34.51,2.08,2.08,0,0,1-.52.39l-1.26.74,2.26,1.31a.47.47,0,0,1,.17.21.66.66,0,0,1,.07.3v1.47a.28.28,0,0,1-.07.22.12.12,0,0,1-.17,0l-4.75-2.74a.41.41,0,0,1-.17-.21.67.67,0,0,1-.08-.3v-1.2a1.4,1.4,0,0,1,.06-.41.4.4,0,0,1,.2-.25l2.69-1.41a.78.78,0,0,0,.4-.43,1.89,1.89,0,0,0,.08-.53c0-.07,0-.16,0-.29a2.34,2.34,0,0,0-.1-.4,2.55,2.55,0,0,0-.23-.43,1.31,1.31,0,0,0-.41-.36.52.52,0,0,0-.4-.1.43.43,0,0,0-.25.15.83.83,0,0,0-.12.27c0,.1-.05.17-.06.22s-.08.17-.14.18a.43.43,0,0,1-.22-.07l-1.11-.63a.45.45,0,0,1-.14-.18.53.53,0,0,1-.06-.24,4,4,0,0,1,.16-1.07,1.9,1.9,0,0,1,.47-.78,1.16,1.16,0,0,1,.77-.31,2.06,2.06,0,0,1,1.1.34,4.17,4.17,0,0,1,1.05.88,5.88,5.88,0,0,1,.76,1.15,6.79,6.79,0,0,1,.46,1.31A6.18,6.18,0,0,1,454.37,145.3Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.56,150.84l.14.35a2.09,2.09,0,0,0,.19.36,1.67,1.67,0,0,0,.26.35,1.28,1.28,0,0,0,.36.29.75.75,0,0,0,.36.13.44.44,0,0,0,.3,0,.48.48,0,0,0,.21-.25,1.09,1.09,0,0,0,.08-.48,1.85,1.85,0,0,0-.24-.91,1.68,1.68,0,0,0-.65-.67.59.59,0,0,0-.24-.09h-.21l-.17,0a.21.21,0,0,1-.14,0l-1.4-.81a.58.58,0,0,1-.18-.22.54.54,0,0,1-.06-.3l.27-4.79a.34.34,0,0,1,.07-.22.12.12,0,0,1,.17,0l3.85,2.22a.46.46,0,0,1,.17.21.66.66,0,0,1,.07.3v1.47a.28.28,0,0,1-.07.22.12.12,0,0,1-.17,0l-2.62-1.52-.06,1.2a.91.91,0,0,1,.37,0,1.32,1.32,0,0,1,.47.18,4.11,4.11,0,0,1,1,.78,5.32,5.32,0,0,1,.78,1.08,5.65,5.65,0,0,1,.51,1.32,6.18,6.18,0,0,1,.19,1.51,3.68,3.68,0,0,1-.21,1.35,1.44,1.44,0,0,1-.56.75,1.16,1.16,0,0,1-.83.18,2.7,2.7,0,0,1-1-.37,4.91,4.91,0,0,1-1.1-.87,5.57,5.57,0,0,1-.81-1.13,5.93,5.93,0,0,1-.51-1.23,4.53,4.53,0,0,1-.19-1.21.31.31,0,0,1,.05-.19.13.13,0,0,1,.15,0l1.14.66a.66.66,0,0,1,.22.22A1.88,1.88,0,0,1,457.56,150.84Z",
    style: {
      fill: "#C86868"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.75,354.61c-.08-.17-5.57-9.7-5.57-9.7s1.18.7,6.7-2.41a34.39,34.39,0,0,0,5.74-4.39l3.66,7.05c2.33,2.48,7.22-.22,12.79-2.37.93-.36,1.88-.78,2.83-1.21l.06,0c3.05-1,6.65.06,4.12,3.55s-7.58,5.87-12.25,8C256.21,355.75,246.33,360.18,243.75,354.61Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,342.94a6.19,6.19,0,0,1,1.25,3c.18,1.17-1.63,5.79-6,9.46s-10.51,5.45-13.18,7-4.89,3.94-8.08,5.66-6.44,3-10.44,1.68c-.88-.81-2.17-2.86-2-3.13C246.63,366,284.71,342.94,284.71,342.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.44,345.93c2.59.94,6.86-1.3,11.63-3.14,4.49-1.74,9.28-4.73,12.72-4.46s7,3.29,4,9.15c-.88,1.7-2.85,4.8-4.74,6.09-4.79,3.27-9.5,4.66-12.68,6.39-4.14,2.25-6.05,4.84-10,6.39-5.14,2-8.85,1.51-10.13.34s-5.12-12.37-2.79-12.72c0,0,1.92,3.44,9.64-2.41C256.46,349,255.8,346.72,255.44,345.93Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.44,345.93c2.59.94,6.86-1.3,11.63-3.14,4.49-1.74,9.28-4.73,12.72-4.46s7,3.29,4,9.15c-.88,1.7-2.85,4.8-4.74,6.09-4.79,3.27-9.5,4.66-12.68,6.39-4.14,2.25-6.05,4.84-10,6.39-5.14,2-8.85,1.51-10.13.34s-5.12-12.37-2.79-12.72c0,0,1.92,3.44,9.64-2.41C256.46,349,255.8,346.72,255.44,345.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.73,348.21s-1.76-4.68-5.65-5a1.93,1.93,0,0,0-1.9.77s3.43-.38,6,5c0,0,.27.32.95,0C271.36,348.84,271.86,348.6,271.73,348.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.25,345.12s-.05-.16.75-.54a1.5,1.5,0,0,1,1-.14s3,.45,4.77,5.36a.93.93,0,0,1-.61,1,.76.76,0,0,1-1.08-.25S264.15,345.39,261.25,345.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,346s.07-.35.7-.5c.79-.21,1.05,0,1.05,0s2.4,1.44,3.52,5.65c0,0,.26.69-.71,1s-1-.51-1-.51S260.19,346.41,258.42,346Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.86,285.8c7.75,11.91,31,53.79,31,53.79s-5.73,8.68-14.66,7.74l-34-50.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.29,372.08c-1.16-1.15-6.39-9.72-6.39-9.72s3.92,1.3,9.68-1.35c2.93-1.35,5.13-5.27,5.13-5.27l4.37,8.37c2.13,2.66,6.87.68,12.59-1,1-.28,1.94-.62,2.92-1l.06,0c3.13-.73,6.62.61,3.82,3.87s-8,5.24-12.87,7C289.8,375.13,280.66,376.4,276.29,372.08Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.45,362.71a6.64,6.64,0,0,1,1.07,3.37c.1,1.27-2.24,6.05-7.25,9.6s-11.72,4.91-14.72,6.38-5.57,3.79-9.14,5.35-7.16,2.69-11.33.88c-.87-.94-2.06-3.25-1.88-3.53C278.68,384,321.45,362.71,321.45,362.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.9,363.26a11.59,11.59,0,0,0,1.24.46,3.61,3.61,0,0,0,1.27,0,17.65,17.65,0,0,0,3-.52c2.43-.62,4.8-1.48,7.21-2.19,5-1.47,10.35-4.25,14-3.66s7.58,4,3.84,10.06a23.79,23.79,0,0,1-5.4,6.12c-5.17,3.49-11.11,4.23-14.67,5.8-4.62,2.05-6.89,4.65-11.28,6-5.67,1.69-9.6.84-10.87-.53-.71-.76-1-5.41-2.46-8.79-1.24-2.9-1.49-5-.37-5.08a5.38,5.38,0,0,0,1.06.9,4.21,4.21,0,0,0,1.49.76,10.51,10.51,0,0,0,2.31.29,12.77,12.77,0,0,0,4.14-.26,1.94,1.94,0,0,0,1-.56,2.29,2.29,0,0,0,.36-1.5c0-.46,0-.93,0-1.39a2.06,2.06,0,0,1,.1-.75,1.9,1.9,0,0,1,.58-.68,5.93,5.93,0,0,0,1.86-2.13,5.1,5.1,0,0,0,.23-2.2.58.58,0,0,1,.08-.37c.14-.16.4-.1.6,0S289.67,363.16,289.9,363.26Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.9,363.26a11.59,11.59,0,0,0,1.24.46,3.61,3.61,0,0,0,1.27,0,17.65,17.65,0,0,0,3-.52c2.43-.62,4.8-1.48,7.21-2.19,5-1.47,10.35-4.25,14-3.66s7.58,4,3.84,10.06a23.79,23.79,0,0,1-5.4,6.12c-5.17,3.49-11.11,4.23-14.67,5.8-4.62,2.05-6.89,4.65-11.28,6-5.67,1.69-9.6.84-10.87-.53-.71-.76-1-5.41-2.46-8.79-1.24-2.9-1.49-5-.37-5.08a5.38,5.38,0,0,0,1.06.9,4.21,4.21,0,0,0,1.49.76,10.51,10.51,0,0,0,2.31.29,12.77,12.77,0,0,0,4.14-.26,1.94,1.94,0,0,0,1-.56,2.29,2.29,0,0,0,.36-1.5c0-.46,0-.93,0-1.39a2.06,2.06,0,0,1,.1-.75,1.9,1.9,0,0,1,.58-.68,5.93,5.93,0,0,0,1.86-2.13,5.1,5.1,0,0,0,.23-2.2.58.58,0,0,1,.08-.37c.14-.16.4-.1.6,0S289.67,363.16,289.9,363.26Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.09,367.22s-1.46-5.17-5.6-5.88a2.09,2.09,0,0,0-2.1.66s3.71-.11,6,5.86c0,0,.25.37,1,.09C306.64,367.86,307.21,367.65,307.09,367.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.15,363s0-.17.85-.5a1.65,1.65,0,0,1,1.09-.07s3.12.74,4.63,6.15a1,1,0,0,1-.74,1,.83.83,0,0,1-1.14-.36S299.23,363.53,296.15,363Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05,363.65s.11-.36.79-.47c.86-.15,1.12.15,1.12.15s2.44,1.75,3.27,6.35c0,0,.22.76-.85,1s-1.07-.63-1.07-.63S294.91,364.28,293.05,363.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,302.91c5.6,9.94,19.5,39.7,26.67,54.47a22.61,22.61,0,0,1-14.36,8.06L234,313.71l11.2-9.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.12,292.68s45.42-13.71,53.32-15.87,22.38-5.06,26.81-3.07,6.93,5.48,9.63,9.74c2.8,4.42,4.86,8.45,4.86,8.45S196,300.06,178,300.06,131.12,292.68,131.12,292.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,274.82c-2.85,9.73-6.56,27.07,6.55,39.73,5.11,4.94,34.42,20.65,52.42,15.13,20.11-6.17,44.12-18.06,44.12-18.06s12.14.71,16.09-1.57,6.35-6.05,5.83-7.14c-6.27-13-11.49-19.76-25.06-18.4-16.6,1.66-44.26,6.7-44.26,6.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.87,204.36c-8.6-7.53-20.67-4.1-27.38,2.43-10.28,10-16.38,22.7-14.12,29C163,243,201.87,204.36,201.87,204.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.47,248.41c.18-1.25-.83-2.67-2.87-3.71l-23.8-12.17a17,17,0,0,0-11.57-.8l-21.76,7.5c-1.9.66-2.94,1.58-3,2.48-.05.66-.4,3.22-.42,3.95s.45,1.27,1.46,1.78c2.44,1.25,7.91,1.66,12.21.92l5.52-.94c4.3-.74,9.76-.33,12.19.9a7.08,7.08,0,0,1,3.34,3.41l-1.28,4.43a3.53,3.53,0,0,0,0,2.5l-.4,1.4c-.49,1.67-.65,3.42,3.51,5.26a8.66,8.66,0,0,0,8.36-.33l16.87-11a2.49,2.49,0,0,0,1.24-1.74C303.15,251.6,303.38,249.05,303.47,248.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.87,254.71l.08-11.54-7.18-1.88-.65,6.08a12.07,12.07,0,0,1,3.31.95,7.08,7.08,0,0,1,3.34,3.41l-.52,1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.15,245.73c2.17,2,2.33,2.59,1.73,10.47s-2.39,8.09-4.41,6.74-3.39-5.1-5.87-3.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,243.54c2.44,1.25,7.91,1.66,12.21.92l5.52-.94c4.3-.74,9.76-.33,12.19.9s4,3.6,3.51,5.27l-1.87,6.47c-.49,1.67-.65,3.42,3.51,5.26a8.67,8.67,0,0,0,8.36-.33l16.87-10.95c2.19-1.42,1.46-3.86-1.63-5.44l-23.8-12.17a17,17,0,0,0-11.57-.8l-21.76,7.5C240.17,240.37,239.48,242.3,241.93,243.54Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,243.54c2.44,1.25,7.91,1.66,12.21.92l5.52-.94c4.3-.74,9.76-.33,12.19.9s4,3.6,3.51,5.27l-1.87,6.47c-.49,1.67-.65,3.42,3.51,5.26a8.67,8.67,0,0,0,8.36-.33l16.87-10.95c2.19-1.42,1.46-3.86-1.63-5.44l-23.8-12.17a17,17,0,0,0-11.57-.8l-21.76,7.5C240.17,240.37,239.48,242.3,241.93,243.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.81,244.64a.76.76,0,0,0-.47-.59,3.5,3.5,0,0,0-2.7-.11c-.42.17-.63.4-.65.65s-.09.77-.1.94.15.45.47.63a3.55,3.55,0,0,0,2.7.12c.4-.16.62-.39.65-.63S294.82,244.83,294.81,244.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.06,247a.76.76,0,0,0-.47-.62,3.5,3.5,0,0,0-2.7-.11c-.4.16-.62.39-.64.62s-.1.81-.11,1a.76.76,0,0,0,.47.62,3.55,3.55,0,0,0,2.7.12c.4-.16.62-.39.65-.62S289.06,247.19,289.06,247Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.41,244.45c0-.22-.15-.45-.47-.63a3.55,3.55,0,0,0-2.7-.12c-.4.16-.62.39-.65.63s-.08.79-.1.95.14.46.47.65a3.5,3.5,0,0,0,2.7.11c.41-.16.63-.4.65-.64S289.4,244.62,289.41,244.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,247.27c0-.22-.14-.45-.47-.63a3.47,3.47,0,0,0-2.69-.12c-.4.16-.62.39-.65.62s-.08.79-.1,1,.13.46.47.66a3.54,3.54,0,0,0,2.7.11c.4-.16.61-.39.64-.62S294.45,247.44,294.45,247.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,243.94c-.8.32-.87.9-.18,1.29a3.55,3.55,0,0,0,2.7.12c.8-.33.87-.91.18-1.3A3.5,3.5,0,0,0,291.64,243.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.89,246.29c-.79.32-.87.9-.18,1.29a3.55,3.55,0,0,0,2.7.12c.8-.33.88-.91.18-1.3A3.5,3.5,0,0,0,285.89,246.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.24,243.7c-.8.33-.88.9-.18,1.29a3.5,3.5,0,0,0,2.7.12c.79-.32.87-.9.18-1.29A3.55,3.55,0,0,0,286.24,243.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,246.52c-.8.32-.88.9-.18,1.29a3.55,3.55,0,0,0,2.7.12c.79-.33.87-.9.17-1.29A3.47,3.47,0,0,0,291.29,246.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.15 234.12 270.62 232.71 267.75 233.88 265.22 232.47 262.34 233.65 262.23 234.72 263.7 235.54 262 236.23 261.88 237.3 264.41 238.71 267.28 237.53 269.81 238.94 272.68 237.77 272.8 236.7 271.33 235.88 273.03 235.18 273.15 234.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.62 232.71 267.75 233.88 265.22 232.47 262.34 233.65 264.87 235.06 262 236.23 264.52 237.64 267.4 236.47 269.92 237.88 272.8 236.7 270.27 235.29 273.15 234.12 270.62 232.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.4 236.47 267.28 237.53 264.41 238.71 264.52 237.64 267.4 236.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.27 235.29 271.33 235.88 273.03 235.18 273.15 234.12 270.27 235.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.8 236.7 272.68 237.77 269.81 238.94 269.92 237.88 272.8 236.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.87 235.06 262.34 233.65 262.22 234.77 263.7 235.54 264.87 235.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.25,231.83c6-1.36,9.57-.31,14.68-.52,1.65-.06,3.05-.95,3.86-.8,1.55.3,1.43,1.91.43,3s-2.15,2.12-6.58,2.81c-3.78.6-3.93.17-8.36,1.54l-4.85,2.28-1.7-4.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,231.31a17.72,17.72,0,0,0-10.12-1.16c-4.89,1.16-3.14,6.17-3.14,6.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.89 205.91 215.39 218.88 196.24 212.16 209.92 193.15 229.89 205.91",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,181s4.86,7.38,4.31,8.11-4.14,1.38-4.14,1.38Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.79,160.62c9.84,2.07,12.68,6.4,13.61,22,1,16.34-.7,21.48-2.84,23.68-1.45,1.48-9.5,1.75-13.56.63-5.09-1.4-16.58-5.47-22-13.69-6.32-9.67-8-22.77-1.21-28.15C214.36,157.56,226.79,159.77,230.79,160.62Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.45,207.07c4.23,1.06,10.71.63,12.66-.43a14.61,14.61,0,0,1-7.15-.43,23.43,23.43,0,0,1-6.49-3Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,167.37l0,0c-2.81,1.84-6.19,2.55-9.51,3,.2,2.65-.7,5.25-1.58,7.76-.61,1.74-2.79,7.19-5,4.12-1.57-2.22-3-4.24-6.1-3.77-5.12.76-5.81,7.29-2.59,11.26s6.24,2.45,6.24,2.45.31,7-3.51,11.93a16.75,16.75,0,0,1-13.33.53c-4.86-1.72-11.8-8.07-14.3-12.95-6.87-13.45-6.62-26.17,2.18-29.89,1-6.35,6-9.19,11.64-10.5,7.9-1.82,15.95,3.3,23.61.22,1.62-.65,3.11-1.59,4.76-2.14a3.23,3.23,0,0,1,2.82.07,3.4,3.4,0,0,1,1.16,2.19,6.1,6.1,0,0,1-.4,4.53,13.36,13.36,0,0,1,3.6-1.24,4.5,4.5,0,0,1,3.59.9,4.62,4.62,0,0,1,1.37,3.18C251.49,162.36,249.37,165.53,246.58,167.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,163.94l-5.89-3.47a3.42,3.42,0,0,1,5.89,3.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.87,204.36c-10.84-3.24-19.77-1.6-33.93,11.89C152.42,231,141,256.06,137,283.09c0,0,.53,12.49,15,20.8,15.35,8.81,39.07,6.66,48.6-9.2,0,0,2-14.13,8.33-21.69,4.1-4.9,13.58-15.72,20.58-23.45,6.09-6.73,12.45-23.14,2.88-30.87-2.81-2.26-5.57-4-9.46-6.56C213,213.88,200.09,208,201.87,204.36Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.87,204.36c-10.84-3.24-19.77-1.6-33.93,11.89C152.42,231,141,256.06,137,283.09c0,0,.53,12.49,15,20.8,15.35,8.81,39.07,6.66,48.6-9.2,0,0,2-14.13,8.33-21.69,4.1-4.9,13.58-15.72,20.58-23.45,6.09-6.73,12.45-23.14,2.88-30.87-2.81-2.26-5.57-4-9.46-6.56C213,213.88,200.09,208,201.87,204.36Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.39,248.53l.48-.62.21-.28.52-.74c0-.06.09-.12.13-.19q.33-.49.66-1a.31.31,0,0,0,.05-.1c.2-.31.39-.64.58-1l.13-.24c.17-.31.35-.63.51-1a1.62,1.62,0,0,0,.1-.18,37.29,37.29,0,0,0,1.67-3.8l0-.07a27.38,27.38,0,0,0,1.85-9.77,53.23,53.23,0,0,1-12.45,14.09c-6.33,5-13.77,8.51-19.76,13.9-6.34,5.72-11.36,13-16.91,19.47-2.23,2.58-5.5,7.72-8.9,7.45-4.15-.33-7.35-5.91-9.09-9.69-2.78-6-4.85-13.35-8.59-18.83-3.27-4.79-8.49-11.08-14.14-9.39A141.26,141.26,0,0,0,137,283.09s.53,12.49,15,20.8a35.48,35.48,0,0,0,4,2c.42.07.84.16,1.25.26,2.07.54,4,1.55,6.13,2l.76.15.86.15.92.14.78.11,1,.12.69.06,1.08.08.65,0,1.1,0H173l.7,0,1-.05.79-.06.91-.08.87-.1.83-.11,1-.16.65-.12c.43-.08.85-.16,1.27-.26l.27-.06c7.87-1.85,15.13-6.25,19.37-13.31,0,0,.1-.68.31-1.81.07-.33.14-.69.22-1.09.16-.78.37-1.7.62-2.71a55.55,55.55,0,0,1,3.62-10.39,32,32,0,0,1,1.89-3.41c.35-.54.71-1.06,1.09-1.56L209,273l.83-1c3.85-4.55,10.93-12.64,17-19.43l2.73-3,.66-.78Z",
    style: {
      fill: "#C86868",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.16,264.43c-3.35,5.34-4,8.69-18.49,9.82,0,0-27.19,17.06-35.92,20.19s-11.88-1.78-13.7-9.69S219.46,247,219.46,247s-3.79-18.41,11.67-28.87c6.55,5,10,10.11,11.1,18.91,1.29,10.53,3.17,35.26,3.17,35.26s22.93-10,26.39-13.44a25.19,25.19,0,0,0,2.75-3.49c1.46-2,3.52-4.18,4.1-6.81.91-4.17,2.83-3.59,3.52-1.3a16.6,16.6,0,0,1-.07,9s7.09,5.57,10.57,3.7l.94-.6h0a2,2,0,0,1,2.58.23C296.37,260.55,296.21,261.17,294.16,264.43Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,216.44c8.72,4.11,13,10.68,13.9,20.62s2.11,27.21,2.11,27.21-.54,6.3-8.88,9.23a16,16,0,0,1-14.36-1.66l-3.46-22.5S213.81,225,229.39,216.44Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puff--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--puff--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.06,289.21c-14.27-17.46-27.54-38.41-38.52-44.74-19.76-11.38-59.9,13.63-64.29,70.7S101,404.22,141.73,413c20.85,4.48,48.25-.06,59-3.78,32.77-11.35,51.12-27.23,59-49.18,8.6-24.06,2.09-38.53-9.11-44.69a25.89,25.89,0,0,0-16.49-2.72C194.29,318.87,177.11,302.73,166.06,289.21Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.85,403.15l1.8-.84c2.86-14,1.25-27.12-4.85-39.26-6-11.85-16.19-22.95-31.28-34-22.25-16.23-31-31.63-39.42-46.52-3.09-5.46-6-10.62-9.54-15.71-7.87-11.36-15.72-17.33-24.69-18.77a30,30,0,0,0-11,.38q-1.85,1.2-3.68,2.63a30.76,30.76,0,0,1,14.37-1.42c8.51,1.37,16,7.12,23.63,18.1,3.48,5,6.39,10.16,9.46,15.58,8.52,15.05,17.34,30.6,39.87,47C200,344.58,223.91,367.16,215.85,403.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,413c20.85,4.48,48.25-.06,59-3.78,32.77-11.35,51.12-27.23,59-49.18.21-.59.39-1.16.58-1.74l-.48-.19c-8.39-2.73-17.41.54-25.72,3.49-20.9,7.42-44.52,12.91-64.75,3.84-13.32-6-27.05-15.33-34.13-28.1s-10.35-27.36-15.49-41c-2.32-6.15-4.48-14.1-9.7-20.09-4.89-5.6-11.34-9.67-18.77-9.66-6.1,0-11.74,1.84-17,8.06-5.68,10.91-9.77,24.47-11,40.58C58.86,372.25,101,404.22,141.73,413Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Console--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--console--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.45,365.54l28.4-16.4a5.65,5.65,0,0,0,2.55-4.42v.33a5.64,5.64,0,0,0-2.55-4.42l-57.11-33a5.66,5.66,0,0,0-5.1,0l-28.4,16.4a5.62,5.62,0,0,0-2.55,4.41v-.32a5.62,5.62,0,0,0,2.55,4.41l57.11,33A5.66,5.66,0,0,0,433.45,365.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.91,322.77l30.95,17.86a5.64,5.64,0,0,1,2.55,4.42v-.33a5.65,5.65,0,0,1-2.55,4.42l-28.4,16.4a5.31,5.31,0,0,1-2.55.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.86,343.58,433.46,360a5.59,5.59,0,0,1-5.1,0l-57.11-33c-1.41-.81-1.41-2.13,0-2.94l28.4-16.4a5.66,5.66,0,0,1,5.1,0l57.11,33C463.27,341.45,463.27,342.77,461.86,343.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.86,338.19v2.71l-29.48,17a2.74,2.74,0,0,1-1.06.37,2.9,2.9,0,0,1-1.88-.37l-58.19-33.59v-2.81l57.11,33.06a5.63,5.63,0,0,0,5.1,0Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.86,338.19v2.71l-29.48,17a2.74,2.74,0,0,1-1.06.37l-.42,0v-3.12a5.21,5.21,0,0,0,2.56-.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,354.58l28.4-16.39a5.63,5.63,0,0,0,2.55-4.42v-5.25a5.63,5.63,0,0,0-2.55-4.42l-57.11-33a5.66,5.66,0,0,0-5.1,0l-28.4,16.39a5.66,5.66,0,0,0-2.55,4.42v5.25a5.47,5.47,0,0,0,2.55,4.33l57.11,33.06A5.59,5.59,0,0,0,433.46,354.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.91,306.23l30.95,17.87a5.63,5.63,0,0,1,2.55,4.42v5.25a5.63,5.63,0,0,1-2.55,4.42l-28.4,16.39a5.17,5.17,0,0,1-2.55.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.86,327.05l-28.4,16.39a5.66,5.66,0,0,1-5.1,0l-57.11-33c-1.41-.81-1.41-2.13,0-3l28.4-16.39a5.66,5.66,0,0,1,5.1,0l57.11,33C463.27,324.91,463.27,326.23,461.86,327.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.25,314c3.15,1.81,3.15,4.74,0,6.55a12.69,12.69,0,0,1-11.39,0c-3.14-1.81-3.14-4.74,0-6.55A12.56,12.56,0,0,1,422.25,314Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,315.93a2.2,2.2,0,0,1,1,1.74c0,.64-.45.91-1,.6a2.2,2.2,0,0,1-1-1.73C374.88,315.89,375.33,315.62,375.88,315.93Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,319.78a2.21,2.21,0,0,1,1,1.74c0,.64-.45.91-1,.6a2.2,2.2,0,0,1-1-1.73C374.88,319.74,375.33,319.47,375.88,319.78Z",
    style: {
      fill: "#C86868"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.06,150.54v-15l12.67-1.11a.91.91,0,0,1,.52.11c.49.27,10.7,6.14,10.86,6.23a.92.92,0,0,1,.2,1.43l-13.43,14.56Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,156.75l13.43-14.56a.92.92,0,0,0-.76-1.55l-12.67,1.1Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.06,135.52l10.82,6.23,12.67-1.11a1,1,0,0,1,.44.06c-1-.6-10.27-5.92-10.73-6.17a.87.87,0,0,0-.54-.11Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.06,135.52l10.82,6.23,12.67-1.11a1,1,0,0,1,.44.06c-1-.6-10.27-5.92-10.73-6.17a.87.87,0,0,0-.54-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.89,123.57a7,7,0,0,0-3.15-5.45l-2.56-1.47a6.91,6.91,0,0,0-6.29,0L77.63,139.36a6.93,6.93,0,0,0-3.14,5.44V188a6.93,6.93,0,0,0,3.14,5.45l2.56,1.48a7,7,0,0,0,6.29,0l39.26-22.71a6.94,6.94,0,0,0,3.15-5.45Z",
    style: {
      fill: "#C86868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,188a6.93,6.93,0,0,0,3.14,5.45l2.56,1.48a7.06,7.06,0,0,0,5.75.25c-1.48.56-2.6-.28-2.6-2.07v-43.2a6.44,6.44,0,0,1,.92-3.1l-8.85-5.11a6.44,6.44,0,0,0-.92,3.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.78,122.68c-.36-1.34-1.58-1.76-3-.93L86.48,144.47a6.27,6.27,0,0,0-2.22,2.34l-8.84-5.1a6.36,6.36,0,0,1,2.21-2.35l39.26-22.71a7,7,0,0,1,6.29,0l2.57,1.48A6.91,6.91,0,0,1,128.78,122.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Heart--inject-123",
    points: "97.66 147.72 101.21 145.67 101.21 148.29 104.77 146.24 104.77 151.83 108.32 149.77 108.32 144.18 111.88 142.13 111.88 139.51 115.44 137.45 115.44 140.08 118.99 138.02 118.99 143.61 122.55 141.56 122.55 149.77 118.99 151.83 118.99 155.93 115.44 157.99 115.44 162.09 111.88 164.15 111.88 168.25 108.32 170.31 108.33 174.41 104.77 176.46 104.77 172.36 101.21 174.41 101.21 170.31 97.66 172.36 97.66 168.25 94.1 170.31 94.1 166.2 90.54 168.25 90.54 160.04 94.1 157.99 94.1 152.4 97.66 150.34 97.66 147.72",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingAmico);
export default __webpack_public_path__ + "static/media/Gaming-amico.85bcbc07906681151b42ae1bbf0493cf.svg";
export { ForwardRef as ReactComponent };